import { CouponResponseDtos } from '@diritto/common/coupon/dtos/coupon.response.dtos';
import { CouponCatalogApi } from 'api/ApiHelper';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { couponCatalogQueryKey } from 'queries/couponCatalog/queryKeys';

export const useIssueCouponCatalogMutation = (options?: UseMutationOptions<CouponResponseDtos, unknown, number>) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (couponCatalogId: number) => CouponCatalogApi.issueCoupon(couponCatalogId),
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: couponCatalogQueryKey.couponCatalog(variables) });
      options?.onSuccess?.(data, variables, context);
    },
  });
};
